export default __webpack_public_path__ + "static/media/current-seedj.eb6da210.png";